var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/RedeemCard/RedeemCard.scss";
import { Accordion } from "react-bootstrap";
import GenericDetails from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
export var RedeemCard = function (_a) {
    var amount = _a.amount, timestamp = _a.timestamp, units = _a.units, genericDetailsAccordianData = _a.genericDetailsAccordianData, leftTitle = _a.leftTitle, onDetailsClick = _a.onDetailsClick, _b = _a.accordionTitle, accordionTitle = _b === void 0 ? "More Details" : _b, _c = _a.accordionTitleExpanded, accordionTitleExpanded = _c === void 0 ? "Less Details" : _c, tooltipRef = _a.tooltipRef;
    var _d = __read(useState(false), 2), isExpanded = _d[0], setIsExpanded = _d[1];
    var toggleAccordion = function () {
        setIsExpanded(function (prev) { return !prev; });
    };
    return (React.createElement("section", { className: "primary-redeem-container-block d-flex justify-content-center  flex-column", ref: tooltipRef },
        React.createElement("div", { className: "contentWrapper d-flex flex-column w-100 mb-3" },
            React.createElement("div", { className: "infoContainer d-flex w-100" },
                React.createElement("div", { className: "valueSection d-flex flex-column justify-content-center align-items-start" },
                    React.createElement("span", { className: "label DMSans_13_400" }, leftTitle),
                    React.createElement("div", { className: "amountWrapper d-flex flex-column justify-content-center mt-1" },
                        React.createElement("span", { className: "amount DMSanN_15_400" },
                            "\u20B9",
                            amount),
                        React.createElement("span", { className: "timestamp DMsanR_10_400" },
                            "(As Of ",
                            timestamp,
                            ")"))),
                React.createElement("div", { className: "divider bg-light border mx-0", role: "separator" }),
                React.createElement("div", { className: "unitsSection d-flex flex-column flex-grow-1" },
                    React.createElement("span", { className: "label DMSans_13_400" }, "Units"),
                    React.createElement("span", { className: "unitsValue mt-1 DMSanN_15_400" }, units)))),
        React.createElement(Accordion, null,
            React.createElement(Accordion.Item, { eventKey: "0" },
                React.createElement(Accordion.Body, null,
                    React.createElement(GenericDetails, { details: genericDetailsAccordianData })),
                React.createElement(Accordion.Header, { className: "DMSans_13_400", onClick: toggleAccordion },
                    isExpanded ? accordionTitleExpanded : accordionTitle,
                    React.createElement("span", { className: "edel-icon-arrow-".concat(isExpanded ? "up-thin" : "down") }))))));
};
